import { IList } from 'annotation-tools/utils';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { IBboxType } from '../imports/annotation-canvas';
import { get, IRectType, useStreamEffect } from '../imports/utils';
import { AppMode } from '../types/enum/app-mode';

export const useSideEffects = (
  bboxListRelative$: Observable<{
    lastOp: 'input' | 'inference' | 'canvas';
    bboxList: IList<IBboxType>;
  }>,
  onBboxesRelativeChange: (v: IList<IBboxType>) => void,
  currentPageIndex$: Observable<number>,
  onPageIndexChange: (v: number) => void,
  cropRectRelative$: Observable<{
    lastOp: 'input' | 'canvas';
    cropRect: IRectType;
  }>,
  onCropRectRelativeChange: (v: IRectType) => void,
  inferClick$: Observable<'infer'>,
  onInferClick: () => void,
  openSettingsDialogClick$: Observable<'settings'>,
  onOpenSettingsDialogClick: () => void,
  backToListPageClick$: Observable<'back-to-list'>,
  onBackToListPageClick: () => void,
  appMode$: Observable<AppMode>,
  onAppModeChange: (v: AppMode) => void
) => {
  useStreamEffect(
    bboxListRelative$.pipe(
      filter(e => e.lastOp === 'canvas'),
      get('bboxList')
    ),
    onBboxesRelativeChange
  );

  useStreamEffect(currentPageIndex$, onPageIndexChange);

  useStreamEffect(
    cropRectRelative$.pipe(
      filter(e => e.lastOp === 'canvas'),
      get('cropRect')
    ),
    onCropRectRelativeChange
  );

  useStreamEffect(inferClick$, onInferClick);
  useStreamEffect(openSettingsDialogClick$, onOpenSettingsDialogClick);
  useStreamEffect(backToListPageClick$, onBackToListPageClick);
  useStreamEffect(appMode$, onAppModeChange);
};
